/* 
    为了兼容tag之前的设计及用法
    { id: 'draft', text: '草稿', ...tagColors.blue},
*/
export const tagColors = {
    //蓝色
    blue: { color: '#1F6EEF', bdColor: '#4994FC', bgColor: '#EDF7FF' },
    //深蓝色
    moreBlue: { color: '#00237D', bdColor: '#00237D', bgColor: '#EDF7FF' },
    //橙色
    orange: { color: '#ED6A0C', bdColor: '#ED6A0C', bgColor: '#FFF5ED' },
    //深橙色
    moreOrange: { color: '#AD4E09', bdColor: '#AD4E09', bgColor: '#FFF5ED' },
    //红色
    red: { color: '#F5222D', bdColor: '#FF7875', bgColor: '#FFF1F0' },
    //绿色
    green: { color: '#217930', bdColor: '#66BE74', bgColor: '#F0FAF2' },
    //深绿色
    moreGreen: { color: '#154C1E', bdColor: '#217930', bgColor: '#F0FAF2' },
    //灰色
    gray: { color: '#666666', bdColor: '#999999', bgColor: '#E4E5E6' },
    //浅灰色边框
    lightGray: { color: '#666666', bdColor: '#D8DADD', bgColor: '#F2F3F5' },
    //浅灰色白背景边框
    lightWhiteGray: { color: '#D8DADD', bdColor: '#D8DADD', bgColor: '#FFFFFF' },

    //紫色
    violet: { color: '#8A3FD4', bdColor: '#A973DF', bgColor: '#F7F2FC'},

    //蓝色无边框
    blueDark: { color: '#1F6EEF', bgColor: '#D8EAFF' },
    //橙色无边框
    orangeDark: { color: '#ED6A0C', bgColor: '#FFE1CC' },
    //红色无边框
    redDark: { color: '#F5222D', bgColor: '#FFE3E3' },
    //紫色无边框
    violetDark: { color: '#8A3FD4', bgColor: '#F0E1FF'},
    //浅紫色无边框
    violetTwoDark: { color: '#9E61DC', bgColor: '#F7F2FC'},
    //绿色无边框
    greenDark: { color: '#217930',  bgColor: '#E7F8EA' },
    //黄色无边框
    yellowDark: { color: '#726006',  bgColor: '#FFF3B6' },
    //深紫无边框
    moreVioletDark: { color: '#363687',  bgColor: '#E5E5FF' },
    //浅灰色边框
    lightGrayDark: { color: '#999999', bgColor: '#F2F3F5' },

    //text 深灰色
    gray6Text:{color:'#666666'},
    //text 浅灰色
    gray9Text:{color:'#999999'},
    //text 绿色
    greenText:{color:'#2DA641'},
    //text 橙色
    orangeText:{color:'#ED6A0C'},
    //text 红色
    redText:{color:'#F5222D'},
    //text 蓝色
    blueText:{color:'#1F6EEF'},
    violetText:{color:'#8A3FD4'}
}
